export interface AuthUser {
  id: string;
  name: string;
  email: string;
  accessLevel: 'free' | 'supporter' | string;
}

const TOKEN_KEY = 'partitura:auth-token:v1';

export function getToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string | null) {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // segue apenas na sessão atual
  }
}

export async function apiRequest<T>(
  path: string,
  options: Parameters<typeof fetch>[1] = {},
  tokenOverride?: string | null,
): Promise<T> {
  const token = tokenOverride === undefined ? getToken() : tokenOverride;
  const headers = new Headers(options.headers);
  headers.set('Content-Type', 'application/json');
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(path, { ...options, headers, cache: 'no-store' });
  let body: unknown = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    const error = new Error('api_error') as Error & { status?: number; code?: string };
    error.status = response.status;
    error.code =
      body && typeof body === 'object' && 'error' in body
        ? String((body as { error: unknown }).error)
        : 'unknown';
    throw error;
  }
  return body as T;
}
